'use strict';
var parent = require('../../stable/object/define-property');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/actual/object/define-property.js
// module id = 543
// module chunks = 13